var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { GraphQLNonEmptyString } from "graphql-scalars";
import { DateTime } from "luxon";
import { ArgsType, Field, InputType, ObjectType } from "type-graphql";
import { FilteredListQueryArgs } from "../filtering/FilteredListQueryArgs.js";
import { MarathonHourNode } from "../resources/MarathonHour.js";
import { DateTimeScalar } from "../scalars/DateTimeISO.js";
import { AbstractGraphQLPaginatedResponse } from "./PaginatedResponse.js";
let ListMarathonHoursResponse = class ListMarathonHoursResponse extends AbstractGraphQLPaginatedResponse {
    data;
};
__decorate([
    Field(() => [MarathonHourNode], { nullable: false }),
    __metadata("design:type", Array)
], ListMarathonHoursResponse.prototype, "data", void 0);
ListMarathonHoursResponse = __decorate([
    ObjectType("ListMarathonHoursResponse", {
        implements: (AbstractGraphQLPaginatedResponse),
    })
], ListMarathonHoursResponse);
export { ListMarathonHoursResponse };
let CreateMarathonHourInput = class CreateMarathonHourInput {
    title;
    details;
    durationInfo;
    shownStartingAt;
};
__decorate([
    Field(() => GraphQLNonEmptyString, { nullable: false }),
    __metadata("design:type", String)
], CreateMarathonHourInput.prototype, "title", void 0);
__decorate([
    Field(() => GraphQLNonEmptyString, { nullable: true }),
    __metadata("design:type", Object)
], CreateMarathonHourInput.prototype, "details", void 0);
__decorate([
    Field(() => GraphQLNonEmptyString, { nullable: false }),
    __metadata("design:type", String)
], CreateMarathonHourInput.prototype, "durationInfo", void 0);
__decorate([
    Field(() => DateTimeScalar, { nullable: false }),
    __metadata("design:type", DateTime)
], CreateMarathonHourInput.prototype, "shownStartingAt", void 0);
CreateMarathonHourInput = __decorate([
    InputType()
], CreateMarathonHourInput);
export { CreateMarathonHourInput };
let SetMarathonHourInput = class SetMarathonHourInput {
    title;
    details;
    durationInfo;
    shownStartingAt;
};
__decorate([
    Field(() => GraphQLNonEmptyString, { nullable: false }),
    __metadata("design:type", String)
], SetMarathonHourInput.prototype, "title", void 0);
__decorate([
    Field(() => GraphQLNonEmptyString, { nullable: true }),
    __metadata("design:type", Object)
], SetMarathonHourInput.prototype, "details", void 0);
__decorate([
    Field(() => GraphQLNonEmptyString, { nullable: false }),
    __metadata("design:type", String)
], SetMarathonHourInput.prototype, "durationInfo", void 0);
__decorate([
    Field(() => DateTimeScalar, { nullable: false }),
    __metadata("design:type", DateTime)
], SetMarathonHourInput.prototype, "shownStartingAt", void 0);
SetMarathonHourInput = __decorate([
    InputType()
], SetMarathonHourInput);
export { SetMarathonHourInput };
let ListMarathonHoursArgs = class ListMarathonHoursArgs extends FilteredListQueryArgs("MarathonHourResolver", [
    "title",
    "details",
    "durationInfo",
    "marathonYear",
    "shownStartingAt",
    "createdAt",
    "updatedAt",
]) {
};
ListMarathonHoursArgs = __decorate([
    ArgsType()
], ListMarathonHoursArgs);
export { ListMarathonHoursArgs };
//# sourceMappingURL=ListMarathonHoursResponse.js.map